export type SquadData = {
  captain: string;
  squadSize: number;
  uncappedPlayers: string[];
  keyReturnees: string[];
  playersToWatch: string[];
  selectionNotes: string[];
  forwards: string[];
  backs: string[];
};

export const squads2026: Record<string, SquadData> = {
  "south-africa": {
    captain: "Siya Kolisi",
    squadSize: 44,

    uncappedPlayers: [
      "Zachary Porthen",
      "Cameron Hanekom",
      "Ethan Hooker",
      "Quan Horn",
      "Morne van den Berg",
      "Edwill van der Merwe"
    ],

    keyReturnees: [
      "Sacha Feinberg-Mngomezulu",
      "Lood de Jager",
      "Siya Kolisi",
      "Morne van den Berg"
    ],

    playersToWatch: [
      "Cameron Hanekom",
      "Sacha Feinberg-Mngomezulu",
      "Ethan Hooker"
    ],

    selectionNotes: [
      "44-man squad named for the four-Test series against New Zealand in August–September 2026.",
      "The squad is focused on the 'Rugby's Greatest Rivalry' tour.",
      "Key players rested: Cheslin Kolbe, Damian Willemse, Jesse Kriel, Ruan Nortje.",
      "Several players unavailable: Ox Nche (recovering), Franco Mostert (recovering), Pieter-Steph du Toit, Malcolm Marx, RG Snyman, Jean Kleyn, Kwagga Smith.",
      "Siya Kolisi continues as captain and returns from injury.",
      "Six uncapped players selected."
    ],

    forwards: [
      "Lood de Jager",
      "Ben-Jason Dixon",
      "Thomas du Toit",
      "Eben Etzebeth",
      "Johan Grobbelaar",
      "Cameron Hanekom",
      "Siya Kolisi",
      "Elrigh Louw",
      "Wilco Louw",
      "Zachary Porthen",
      "Gerhard Steenekamp",
      "Marco van Staden",
      "Boan Venter",
      "Jan-Hendrik Wessels",
      "Cobus Wiese",
      "Ntuthuko Mchunu",
      "Ox Nche (recovering)",
      "Franco Mostert (recovering)",
      "Pieter-Steph du Toit",
      "Malcolm Marx",
      "RG Snyman (unavailable)",
      "Jean Kleyn (unavailable)",
      "Kwagga Smith (unavailable)"
    ],

    backs: [
      "Andre Esterhuizen",
      "Aphelele Fassi",
      "Sacha Feinberg-Mngomezulu",
      "Ethan Hooker",
      "Quan Horn",
      "Herchel Jantjies",
      "Canan Moodie",
      "Handre Pollard",
      "Cobus Reinach",
      "Morne van den Berg",
      "Edwill van der Merwe",
      "Cheslin Kolbe (rested)",
      "Damian Willemse (rested)",
      "Jesse Kriel (rested)",
      "Damian de Allende"
    ]
  },

  "new-zealand": {
    captain: "Ardie Savea",
    squadSize: 44,

    uncappedPlayers: [
      "Siale Lauaki",
      "Semisi Tupou Ta'eiloa",
      "Josh Jacomb",
      "Fehi Fineanganofo"
    ],

    keyReturnees: [
      "Ardie Savea",
      "Codie Taylor",
      "Beauden Barrett",
      "Will Jordan"
    ],

    playersToWatch: [
      "Ruben Love",
      "Wallace Sititi",
      "Fehi Fineanganofo"
    ],

    selectionNotes: [
      "44-man squad named by Coach Dave Rennie for the 'Rugby's Greatest Rivalry' tour.",
      "Captain Ardie Savea will join the tour 10 days before the first Test.",
      "Four uncapped players selected.",
      "Key players unavailable: Tamaiti Williams (injury), Scott Barrett (injury), Leicester Fainga'anuku (injury).",
      "Strong squad depth with experienced players across all positions."
    ],

    forwards: [
      "Asafo Aumua",
      "Codie Taylor",
      "Samisoni Taukei'aho",
      "George Bell",
      "Ethan De Groot",
      "George Bower",
      "Xavier Numia",
      "Ollie Norris",
      "Tyrel Lomax",
      "Fletcher Newell",
      "Pasilio Tosi",
      "Siale Lauaki",
      "Tupou Vaa'i",
      "Patrick Tuipulotu",
      "Josh Lord",
      "Sam Darry",
      "Fabian Holland",
      "Peter Lakai",
      "Simon Parker",
      "Ethan Blackadder",
      "Luke Jacobson",
      "Anton Segner",
      "Ardie Savea",
      "Wallace Sititi",
      "Semisi Tupou Ta'eiloa"
    ],

    backs: [
      "Cam Roigard",
      "Cortez Ratima",
      "Kyle Preston",
      "Ruben Love",
      "Beauden Barrett",
      "Damian McKenzie",
      "Josh Jacomb",
      "Jordie Barrett",
      "Quinn Tupaea",
      "Billy Proctor",
      "Anton Lienert-Brown",
      "Timoci Tavatavanawai",
      "Caleb Clarke",
      "Fehi Fineanganofo",
      "Leroy Carter",
      "Josh Moorby",
      "Will Jordan",
      "Rieko Ioane",
      "Emoni Narawa"
    ]
  },
  "ireland": {
    captain: "Dan Sheehan",
    squadSize: 36,

    uncappedPlayers: [
      "Billy Bohan",
      "Sam Illo",
      "Sean Jansen"
    ],

    keyReturnees: [
      "Josh van der Flier",
      "Bundee Aki"
    ],
    
    playersToWatch: [
  "Sam Prendergast",
  "Cormac Izuchukwu",
  "Jamie Osborne"
],
    selectionNotes: [
      "Dan Sheehan assumes captaincy.",
      "Several Connacht newcomers included.",
      "Caelan Doris unavailable through injury."
    ],

    forwards: [
      "Tadhg Beirne",
      "Billy Bohan",
      "Thomas Clarkson",
      "Jack Conan",
      "Tadhg Furlong",
      "Sam Illo",
      "Cormac Izuchukwu",
      "Sean Jansen",
      "Ronan Kelleher",
      "Jeremy Loughman",
      "Joe McCarthy",
      "Darragh Murray",
      "Tom O'Toole",
      "Cian Prendergast",
      "James Ryan",
      "Dan Sheehan",
      "Tom Stewart",
      "Nick Timoney",
      "Josh van der Flier"
    ],

    backs: [
      "Bundee Aki",
      "Rob Baloucoune",
      "Harry Byrne",
      "Craig Casey",
      "Nathan Doak",
      "Ciaran Frawley",
      "Jamison Gibson-Park",
      "Robbie Henshaw",
      "Hugo Keenan",
      "Stuart McCloskey",
      "Jimmy O'Brien",
      "Tommy O'Brien",
      "Jamie Osborne",
      "Sam Prendergast",
      "Garry Ringrose",
      "Jacob Stockdale"
    ]
  }

  ,
  "australia": {
    captain: "Harry Wilson",
    squadSize: 37,

    uncappedPlayers: [
      "Declan Meredith",
      "Lachlan Shaw",
      "Miles Amatosero"
    ],

    keyReturnees: [
      "James Slipper"
    ],

    playersToWatch: [
  "Joseph-Aukuso Suaalii",
  "Harry Wilson",
  "Max Jorgensen"
],
    selectionNotes: [
      "Joe Schmidt named a 37-player squad.",
      "James Slipper returned to the national setup.",
      "Three uncapped players were selected."
    ],

    forwards: [
      "Allan Alaalatoa",
      "Miles Amatosero",
      "Angus Bell",
      "Charlie Cale",
      "Josh Canham",
      "Nick Champion De Crespigny",
      "Tom Hooper",
      "Fraser McReight",
      "Josh Nasser",
      "Zane Nonggorr",
      "Brandon Paenga-Amosa",
      "Billy Pollard",
      "Aidan Ross",
      "Lachlan Shaw",
      "James Slipper",
      "Carlo Tizzano",
      "Taniela Tupou",
      "Rob Valetini",
      "Jeremy Williams",
      "Harry Wilson"
    ],

    backs: [
      "Jock Campbell",
      "Filipo Daugunu",
      "Ben Donaldson",
      "Josh Flook",
      "Carter Gordon",
      "Len Ikitau",
      "Max Jorgensen",
      "Ryan Lonergan",
      "Tate McDermott",
      "Declan Meredith",
      "Hunter Paisami",
      "Dylan Pietsch",
      "Harry Potter",
      "Joseph-Aukuso Suaalii",
      "Kalani Thomas",
      "Corey Toole",
      "Tom Wright"
    ]
  }

  ,
  "scotland": {
    captain: "Rory Darge",
    squadSize: 36,

    uncappedPlayers: [
      "Gregor Hiddleston",
      "Seb Stephen"
    ],

    keyReturnees: [
      "Finn Russell",
      "Duhan van der Merwe",
      "Pierre Schoeman"
    ],

    playersToWatch: [
  "Rory Darge",
  "Tom Jordan",
  "Freddy Douglas"
],

    selectionNotes: [
      "Gregor Townsend named a 36-player squad.",
      "Two uncapped hookers were included.",
      "The squad contains a strong Glasgow Warriors core."
    ],

    forwards: [
      "Ewan Ashman",
      "Josh Bayliss",
      "Magnus Bradbury",
      "Gregor Brown",
      "Scott Cummings",
      "Rory Darge",
      "Jack Dempsey",
      "Freddy Douglas",
      "Matt Fagerson",
      "Zander Fagerson",
      "Jonny Gray",
      "Gregor Hiddleston",
      "Will Hurd",
      "Nathan McBeth",
      "Liam McConnell",
      "Elliot Millar-Mills",
      "D'Arcy Rae",
      "Alex Samuel",
      "Pierre Schoeman",
      "Seb Stephen",
      "Rory Sutherland",
      "Max Williamson"
    ],

    backs: [
      "Fergus Burke",
      "Jamie Dobie",
      "Darcy Graham",
      "George Horne",
      "Rory Hutchinson",
      "Tom Jordan",
      "Stafford McDowall",
      "Kyle Rowe",
      "Finn Russell",
      "Ollie Smith",
      "Kyle Steyn",
      "Sione Tuipulotu",
      "Duhan van der Merwe",
      "Ben White"
    ]
  }

  ,
  "wales": {
    captain: "Jac Morgan",
    squadSize: 48,

    uncappedPlayers: [
      "Rhys Barratt",
      "Kane James",
      "Harrison Keddie",
      "Ben Warren",
      "Ryan Woodman",
      "Bryn Bradley"
    ],

    keyReturnees: [
      "Jac Morgan",
      "Max Llewellyn",
      "Louis Rees-Zammit"
    ],

    playersToWatch: [
  "Jac Morgan",
  "Blair Murray",
  "Max Llewellyn"
],
    selectionNotes: [
      "Steve Tandy named an extended 48-player squad.",
      "Six uncapped players were selected.",
      "Several players returned from injury."
    ],

    forwards: [
      "Keiron Assiratti",
      "Rhys Barratt",
      "Adam Beard",
      "Liam Belcher",
      "James Botham",
      "Rhys Carre",
      "Ben Carter",
      "Olly Cracknell",
      "Ryan Elias",
      "Kane James",
      "Dafydd Jenkins",
      "Harrison Keddie",
      "Dewi Lake",
      "Dillon Lewis",
      "Evan Lloyd",
      "Alex Mann",
      "Jac Morgan",
      "Taine Plumtree",
      "Tommy Reffell",
      "Nicky Smith",
      "Gareth Thomas",
      "Freddie Thomas",
      "Aaron Wainwright",
      "Sam Wainwright",
      "Ben Warren",
      "Teddy Williams",
      "Ryan Woodman"
    ],

    backs: [
      "Josh Adams",
      "Ellis Bevan",
      "Bryn Bradley",
      "Sam Costelow",
      "Dan Edwards",
      "Jarrod Evans",
      "Mason Grady",
      "Kieran Hardy",
      "Gabriel Hamer-Webb",
      "Joe Hawkins",
      "Louie Hennessey",
      "Eddie James",
      "Max Llewellyn",
      "Ellis Mee",
      "Reuben Morgan-Williams",
      "Blair Murray",
      "Louis Rees-Zammit",
      "Joe Roberts",
      "Tom Rogers",
      "Ben Thomas",
      "Tomos Williams"
    ]
  }

  ,
  "fiji": {
    captain: "Tevita Ikanivere",
    squadSize: 32,

    uncappedPlayers: [],

    keyReturnees: [
      "Levani Botia",
      "Peceli Yato",
      "Josua Tuisova",
      "Semi Radradra"
    ],

    playersToWatch: [
  "Caleb Muntz",
  "Jiuta Wainiqolo",
  "Tevita Ikanivere"
],

    selectionNotes: [
      "Tevita Ikanivere captains Fiji.",
      "The squad blends experienced internationals with emerging talent.",
      "Levani Botia and Peceli Yato provide veteran leadership."
    ],

    forwards: [
      "Tevita Ikanivere",
      "Sam Matavesi",
      "Zuriel Togiatama",
      "Eroni Mawi",
      "Atunaisa Sokobale",
      "Peni Ravai",
      "Luke Tagi",
      "Tim Hoyt",
      "Isoa Nasilasila",
      "Mesake Vocevoce",
      "Temo Mayanavanua",
      "Tevita Ratuva",
      "Lekima Tagitagivalu",
      "Kitione Salawa",
      "Elia Canakaivata",
      "Levani Botia",
      "Pita-Gus Sowakula",
      "Peceli Yato"
    ],

    backs: [
      "Frank Lomani",
      "Simione Kuruvoli",
      "Sam Wye",
      "Caleb Muntz",
      "Isaiah Armstrong-Ravula",
      "Josua Tuisova",
      "Filimoni Botitu",
      "Selestino Ravutaumada",
      "Semi Radradra",
      "Jiuta Wainiqolo",
      "Kalaveti Ravouvou",
      "Vinaya Habosi",
      "Salesi Rayasi",
      "Vuate Karawalevu"
    ]
  }

  ,
  "england": {
    captain: "",
    squadSize: 0,
    uncappedPlayers: [],
    keyReturnees: [],
    playersToWatch: [],
    selectionNotes: [
      "Official 2026 squad announcement pending."
    ],
    forwards: [],
    backs: []
  },

  "france": {
    captain: "",
    squadSize: 0,
    uncappedPlayers: [],
    keyReturnees: [],
    playersToWatch: [],
    selectionNotes: [
      "Official 2026 squad announcement pending."
    ],
    forwards: [],
    backs: []
  },

  "italy": {
    captain: "",
    squadSize: 0,
    uncappedPlayers: [],
    keyReturnees: [],
    playersToWatch: [],
    selectionNotes: [
      "Official 2026 squad announcement pending."
    ],
    forwards: [],
    backs: []
  },

  "argentina": {
    captain: "",
    squadSize: 0,
    uncappedPlayers: [],
    keyReturnees: [],
    playersToWatch: [],
    selectionNotes: [
      "Official 2026 squad announcement pending."
    ],
    forwards: [],
    backs: []
  },

  "japan": {
    captain: "",
    squadSize: 0,
    uncappedPlayers: [],
    keyReturnees: [],
    playersToWatch: [],
    selectionNotes: [
      "Official 2026 squad announcement pending."
    ],
    forwards: [],
    backs: []
  }

,
  "england-women": {
    captain: "Megan Jones",
    squadSize: 38,

    uncappedPlayers: [
      "Annabel Meta",
      "Christiana Balogun",
      "Demelza Short",
      "Jodie Verghese",
      "Haineala Lutui",
      "Sarah Parry",
      "Millie David"
    ],

    keyReturnees: [
      "Amy Cokayne",
      "Alex Matthews",
      "Ellie Kildunne"
    ],

    playersToWatch: [
      "Maddie Feaunati",
      "Ellie Kildunne",
      "Millie David"
    ],

    selectionNotes: [
      "John Mitchell named a 38-player squad.",
      "Megan Jones captains the Red Roses.",
      "Seven uncapped players were selected."
    ],

    forwards: [
      "May Campbell",
      "Amy Cokayne",
      "Connie Powell",
      "Sarah Bern",
      "Hannah Botterman",
      "Mackenzie Carson",
      "Kelsey Clifford",
      "Liz Hanlon",
      "Annabel Meta",
      "Maud Muir",
      "Christiana Balogun",
      "Lilli Ives Campion",
      "Demelza Short",
      "Morwenna Talling",
      "Jodie Verghese",
      "Abi Burton",
      "Maddie Feaunati",
      "Daisy Hibbert-Jones",
      "Sadia Kabeya",
      "Haineala Lutui",
      "Alex Matthews",
      "Marlie Packer"
    ],

    backs: [
      "Natasha Hunt",
      "Lucy Packer",
      "Flo Robinson",
      "Holly Aitchison",
      "Zoe Harrison",
      "Tatyana Heard",
      "Megan Jones",
      "Sarah Parry",
      "Helena Rowland",
      "Jess Breach",
      "Millie David",
      "Ellie Kildunne",
      "Claudia Moloney-MacDonald",
      "Emma Sing",
      "Mia Venner",
      "Bo Westcombe-Evans"
    ]
  }

  ,
  "france-women": {
    captain: "Manaé Feleu",
    squadSize: 32,

    uncappedPlayers: [],

    keyReturnees: [
      "Pauline Bourdon Sansus",
      "Gabrielle Vernier",
      "Madoussou Fall Raclot"
    ],

    playersToWatch: [
      "Manaé Feleu",
      "Morgane Bourgeois",
      "Joanna Grisez"
    ],

    selectionNotes: [
      "François Ratier named a 32-player squad.",
      "The squad is heavily drawn from France's domestic competition.",
      "France enter the Six Nations among the favourites."
    ],

    forwards: [
      "Mathilde Lazarko",
      "Élisa Riffonneau",
      "Rose Bernadou",
      "Maïlys Borak",
      "Yllana Brosseau",
      "Annaëlle Deshaye",
      "Assia Khalfaoui",
      "Ambre Mwayembe",
      "Cloé Correa",
      "Madoussou Fall Raclot",
      "Manaé Feleu",
      "Siobhan Soqeta",
      "Kiara Zago",
      "Axelle Berthoumieu",
      "Léa Champon",
      "Khoudedia Cissokho",
      "Charlotte Escudero",
      "Elsa Peyras"
    ],

    backs: [
      "Pauline Bourdon Sansus",
      "Alexandra Chambon",
      "Carla Arbez",
      "Lina Queyroi",
      "Louën Laramy",
      "Gabrielle Vernier",
      "Pauline Barrat",
      "Émilie Boulard",
      "Morgane Bourgeois",
      "Anaïs Grando",
      "Joanna Grisez",
      "Marie Ibañez",
      "Léa Murie",
      "Aubane Rousset"
    ]
  }

  ,
  "wales-women": {
    captain: "Kate Williams",
    squadSize: 38,

    uncappedPlayers: [
      "Elan Jones",
      "Stella Orrin",
      "Kendall Waudby",
      "Jorja Aiono",
      "Jenna De Vera",
      "Savannah Picton-Powell",
      "Kelsie Webster",
      "Nikita Prothero",
      "Seren Singleton"
    ],

    keyReturnees: [
      "Alisha Joyce"
    ],

    playersToWatch: [
      "Kate Williams",
      "Jasmine Joyce",
      "Keira Bevan"
    ],

    selectionNotes: [
      "Sean Lynn named a 38-player squad.",
      "Kate Williams was appointed captain.",
      "Nine uncapped players were selected."
    ],

    forwards: [
      "Katherine Baverstock",
      "Maisie Davies",
      "Elan Jones",
      "Stella Orrin",
      "Gwenllian Pyrs",
      "Donna Rose",
      "Jenni Scoble",
      "Sisilia Tuipulotu",
      "Kelsey Jones",
      "Carys Phillips",
      "Molly Reardon",
      "Kendall Waudby",
      "Gwen Crabb",
      "Georgia Evans",
      "Natalia John",
      "Alaw Pyrs",
      "Jorja Aiono",
      "Alisha Joyce",
      "Bryonie King",
      "Bethan Lewis",
      "Branwen Metcalfe",
      "Tilly Vucaj",
      "Kate Williams"
    ],

    backs: [
      "Keira Bevan",
      "Sian Jones",
      "Seren Lockwood",
      "Lleucu George",
      "Hannah Dallavalle",
      "Jenna De Vera",
      "Savannah Picton-Powell",
      "Kelsie Webster",
      "Carys Cox",
      "Jasmine Joyce",
      "Courtney Keight",
      "Lisa Neumann",
      "Kayleigh Powell",
      "Nikita Prothero",
      "Seren Singleton"
    ]
  }
  
};